import React from 'react';
import '@vibe/core/tokens';
import { Loader } from '@vibe/core';

function LoadingSpreadsheet({
  message = (
    <>
      Loading spreadsheet...
      <br />
      This can take up to a few minutes
    </>
  ),
}: {
  message?: React.ReactNode;
}) {
  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        minHeight: 'inherit',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        <Loader size="medium" color="dark" />
        <div style={{ textAlign: 'center', marginTop: 20 }}>{message}</div>
      </div>
    </div>
  );
}

export default LoadingSpreadsheet;
